import { forwardRef, useCallback, useId } from "react";
import { useState, useRef, useEffect } from "react";
import btnDownArrow from "../../assets/images/svg/btnDownArrow.svg";

const AccessibleDropdown = (
  {
    options,
    selectedIndex,
    onChange,
    disabledIndexes = [],
    label,
    id,
    wrapperClass = "",
  },
  ref
) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(selectedIndex);

  const listRef = useRef(null);

  const dropDownWrapperRef = useRef(null);
  const wrapperId = useId();

  //const id = "date-picker-modal";

  const optionRefs = useRef([]);

  const handleKeyDown = (e) => {
    if (!isOpen) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) =>
        !disabledIndexes.includes(prev + 1) && prev < options.length - 1
          ? prev + 1
          : prev
      );
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        !disabledIndexes.includes(prev - 1) && prev > 0 ? prev - 1 : prev
      );
    }

    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();

      if (!disabledIndexes.includes(activeIndex)) {
        onChange(activeIndex);
      }

      setIsOpen(false);

      requestAnimationFrame(() => {
        document.getElementById(id)?.focus();
      });
    }

    if (e.key === "Escape") {
      setIsOpen(false);
    }
  };

  const onClickOutside = useCallback(() => {
    setIsOpen(false);
  }, []);

  useEffect(() => {
    if (isOpen && optionRefs.current[activeIndex]) {
      optionRefs.current[activeIndex].scrollIntoView({
        block: "nearest",
      });
    }
  }, [activeIndex, isOpen]);

  useEffect(() => {
    if (isOpen && listRef.current) {
      listRef.current.focus();
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropDownWrapperRef.current &&
        !dropDownWrapperRef.current.contains(event.target)
      ) {
        onClickOutside && onClickOutside("month");
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    /// document.addEventListener("mousedown", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      //  document.removeEventListener("mousedown", handleClickOutside, true);
    };
  }, [onClickOutside]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropDownWrapperRef.current &&
        !dropDownWrapperRef.current.contains(event.target)
      ) {
        onClickOutside && onClickOutside("month");
      }
    };
    //   document.addEventListener("click", handleClickOutside, true);
    document.addEventListener("mousedown", handleClickOutside, true);
    return () => {
      //   document.removeEventListener("click", handleClickOutside, true);
      document.removeEventListener("mousedown", handleClickOutside, true);
    };
  }, [onClickOutside]);

  useEffect(() => {
    if (isOpen) {
      setActiveIndex(selectedIndex);
    }
  }, [isOpen, selectedIndex]);

  return (
    <div
      className={`custom-dropdown ${wrapperClass}`}
      ref={dropDownWrapperRef}
      id={wrapperId}
    >
      {/* BUTTON */}
      <button
        id={id}
        ref={ref}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
        aria-label={`${label} dropdown`}
        onClick={() => setIsOpen((prev) => !prev)}
        onKeyDown={handleKeyDown}
        className="drop-down-button"
      >
        <span>{options[selectedIndex]}</span> <img src={btnDownArrow} alt="" />
      </button>

      {/* LIST */}
      {isOpen && (
        <ul
          role="listbox"
          tabIndex={-1}
          ref={listRef}
          aria-activedescendant={`option-${activeIndex}`}
          onKeyDown={handleKeyDown}
          className={`dropdown-list ${isOpen ? "list-open" : ""}`}
        >
          {options.map((opt, index) => {
            const isDisabled = disabledIndexes.includes(index);

            return (
              <li
                key={index}
                ref={(el) => (optionRefs.current[index] = el)}
                id={`option-${index}`}
                role="option"
                aria-selected={selectedIndex === index}
                aria-disabled={isDisabled}
                className={`dropdown-option ${
                  activeIndex === index ? "active" : ""
                } ${isDisabled ? "disabled" : ""}`}
                // onMouseEnter={() => setActiveIndex(index)}
                onClick={() => {
                  if (!isDisabled) {
                    onChange(index);
                    setIsOpen(false);
                    document.getElementById(id).focus();
                  }
                }}
              >
                {opt}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default forwardRef(AccessibleDropdown);
